export default __webpack_public_path__ + "static/media/LoaderGMM.844b34bc.svg";